<template>
    <div>
        <div class="tixstock-tags-skeleton mt-15">
            <div class="tixstock-tags-box-skeleton">
                <div class="search-tag-skeleton"></div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonTixstockTrendingCategories'
}
</script>
<style scoped>

.tixstock-tags-skeleton {
  position: relative;
  width: 100%;
  background: white;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}


.tixstock-tags-box-skeleton {
  padding: 12px 8px;
  background: white;
  width: 100%;
}

.search-tag-skeleton {
  height: 200px;
  background: #e0e0e0;
  border-radius: 4px;
  width: 100%;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    background-color: #f0f0f0;
  }
  50% {
    background-color: #e0e0e0;
  }
  100% {
    background-color: #f0f0f0;
  }
}

</style>